import { apiClient } from "./client";

export const abandonedCartApi = {
  track: async (data) => {
    const response = await apiClient.post("/carts/track", data);
    return response.data;
  },

  updateIdentity: async (cartId, data) => {
    const response = await apiClient.put(`/carts/${cartId}/identity`, data);
    return response.data;
  },

  listMyCarts: async () => {
    const response = await apiClient.get("/carts/my");
    return response.data;
  },

  listAdminCarts: async () => {
    const response = await apiClient.get("/admin-actions/abandoned-carts");
    return response.data;
  },

  getAdminCart: async (cartId) => {
    const response = await apiClient.get(
      `/admin-actions/abandoned-carts/${cartId}`,
    );
    return response.data;
  },

  discardCart: async (cartId) => {
    await apiClient.delete(`/carts/${cartId}/discard`);
  },
};
